// extracted by mini-css-extract-plugin
export default {"containerText":"ModalWebPushConfirm_containerText__OwyuW"};